import { render, staticRenderFns } from "./verifyByPhone.vue?vue&type=template&id=5dfbabfc&scoped=true&"
import script from "./verifyByPhone.vue?vue&type=script&lang=js&"
export * from "./verifyByPhone.vue?vue&type=script&lang=js&"
import style0 from "./verifyByPhone.vue?vue&type=style&index=0&id=5dfbabfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfbabfc",
  null
  
)

export default component.exports